module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-25.37778dd6.png";